export class ProductFilterChangedEvent {
  constructor(public categoryId: string) {
  }
}
